import React, { useState, useEffect, CSSProperties } from 'react';

interface ImgProps {
  src: string;
  fallbackSrc: string;
  alt: string;
  loading?: 'lazy' | 'eager';
  className?: string;
  style?: CSSProperties;
}

const CustomImg: React.FC<ImgProps> = ({
  src,
  fallbackSrc,
  alt,
  loading = 'lazy',
  className = '',
}) => {
  const [currentSrc, setCurrentSrc] = useState<string>(src);

  useEffect(() => {
    setCurrentSrc(src);
  }, [src]);

  const handleError = () => {
    setCurrentSrc(fallbackSrc);
  };

  return (
    <img
      src={currentSrc}
      alt={alt}
      loading={loading}
      className={className}
      onError={handleError}
    />
  );
};

export default CustomImg;
